import { invoicesConstants } from '../constants';

const initialState = {
  loading: false,
  records: []
}

export function invoices(state = initialState, action) {
  switch (action.type) {
    case invoicesConstants.GET_REQUEST:
      return {
        loading: true,
        records: [],
      };
    case invoicesConstants.GET_SUCCESS:
      console.log(action.payload);
      return {
        loading: false,
        records: action.payload,
      };
    case invoicesConstants.GET_FAILURE:
      return {
        loading: false,
        error: action.error,
        records: [],
      };
    default:
      return state
  }
}
